import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface DeleteModuleRequest {
  module_id: number;
}

export function deleteModule(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'DeleteModule',
    description: 'Soft-deletes a module',
    execute: (data: DeleteModuleRequest): Observable<any> => {
      if (!data.module_id) {
        return of({ success: false, error: 'Missing required field: module_id' });
      }
      return componentDataSourceService.http
        .delete<any>(`${environment.apiUrl}/events/modules/${data.module_id}`)
        .pipe(
          tap(() => {
            dataSharingService.setData('modules_updated', {
              timestamp: Date.now(),
              module_id: data.module_id,
            });
          }),
          catchError((err) => {
            console.error('[DeleteModule] Error:', err);
            throw err;
          })
        );
    },
  };
}
